import gql from "graphql-tag";
const getEntityDB_LPAAmendments = gql(`
query MyQuery {
  EntityDB_LPAAmendments {
    AddCommit
    AggCapCommit
    Amend1
    Amend2
    Amend3
    Amend4
    Amend5
    Amend6
    Amend7
    Amend8
    BalCoEntity
    BalCommit
    BorrowLimit
    CapCallPeriod
    CarryPct
    CarryTerms
    CoCommit
    Country
    EntityStatus
    ExcessOrgExpAmt
    ExcessOrgExpCap
    FinalCloseDate
    FundFamily
    GPCommit
    InitClose
    InvAmtExclusions
    InvEndDate
    InvExt1
    InvExt2
    InvExt3
    InvExtProvisions
    InvRestrict
    InvStartDate
    LPCommit
    MFeePct
    MFeeStepDate
    MFeeStepPct
    MFeeStepReason
    MFeeStepStatus
    MFeeStepVerb
    MFeeWaiverProvisions
    MoneyMktAcctRestrict
    PartnerEndDate
    PartnerExt1EndDate
    PartnerExt1Pursuant
    PartnerExt2Date
    PartnerExt2Pursuant
    PartnerExt3Date
    PartnerExt3Pursuant
    PartnerTerm
    PartnerTermExtProvisions
    PreNoticeBorrowList
    PrefReturn
    Purpose
    QuickRef
    SideLetter
    SideLetterQuantity
    Tranche1Commit
    Tranche2Commit
    CompanyName
  }
}`)
export default getEntityDB_LPAAmendments
